import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/components/ui/button/button';
import { FormInput } from '@/shared/components/ui/form/components/form-input/form-input';
import { FormContent } from '@/shared/components/ui/form/form-content';
import { FormContainer } from '@/shared/components/ui/form/form.styled';
import { TLoginWithSsoInputSchema } from '@/shared/features/auth/components/login/login.types';

export const LoginWithSsoForm = () => {
  const { t } = useTranslation();
  const { isSubmitting, isValid } = useFormState();

  return (
    <FormContainer gap="2rem">
      <FormContent>
        <FormInput<TLoginWithSsoInputSchema>
          name="email"
          label={t('auth:work_email')}
          placeholder={t('auth:enter_email')}
          type="email"
          required
        />
      </FormContent>
      <Button
        type="submit"
        variant="primary"
        fullWidth={true}
        size="large"
        disabled={isSubmitting || !isValid}
      >
        {t('auth:sign_in_with_sso')}
      </Button>
    </FormContainer>
  );
};
